import { getLoginProviders, doValidateDomain } from 'redux/actions/sign-in';
import { createReducer } from '@reduxjs/toolkit';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder
    .addCase(getLoginProviders.pending, (state) => {
      state.app.loginProviders.isLoading = true;
    })
    .addCase(getLoginProviders.fulfilled, (state, action) => {
      state.app.loginProviders.isLoading = false;
      state.app.loginProviders.hasBeenLoaded = true;
      state.app.loginProviders.withPassword = action.payload?.withPassword;
    })
    .addCase(doValidateDomain.fulfilled, (state) => {
      state.app.redirecting = true;
    });
});
